<script setup>
import YearMonthPicker from '@/components/Overtime/YearMonthPicker.vue';
import OvertimeTable from '@/components/Overtime/OvertimeTable.vue';
import ApplyOvertime from '@/components/Overtime/ApplyOvertime.vue';
import OvertimeDetail from '@/components/Overtime/OvertimeDetail.vue';
import { onMounted, ref } from 'vue';
import { useToast } from 'vue-toastification';

const toast = useToast();

const year = ref(dayjs().year());
const month = ref(dayjs().month() + 1);
const is_approved = ref('all');
const overtimes = ref([]);
const overtime = ref({});
const perMonth = ref(0);
const perYear = ref(0);

const showModal = ref(false);
const showDetail = ref(false);

const goto = path => {
  window.location.href = path;
};

async function getOvertimes() {
  const response = await axios.get('/api/overtimes', {
    params: {
      year: year.value,
      month: month.value,
      is_approved: is_approved.value,
    },
  });
  overtimes.value = response.data.data;
}

async function getOvertime(id) {
  const response = await axios.get(`/api/overtimes/${id}`);
  showDetail.value = true;
  overtime.value = response.data.data;
}

async function deleteOvertime(id) {
  try {
    await axios.delete(`/api/overtimes/${id}`);
    toast.success('remove overtime success');
    showDetail.value = false;
    await getOvertimes();
  } catch (e) {
    toast.error(e.response.data.message);
  }
}

async function changeYear(operator) {
  if (operator === '+') {
    year.value++;
  } else if (operator === '-') {
    year.value--;
  }
  await getOvertimes();
  await totalOvertimes();
}

async function changeMonth(value) {
  month.value = +value;
  await getOvertimes();
  await totalOvertimes();
}

async function changeIsApproved(value) {
  is_approved.value = value;
  await getOvertimes();
}

async function closeModal() {
  showModal.value = false;
  setTimeout(() => {
    getOvertimes();
  }, 500);
}

async function totalOvertimes() {
  const response = await axios.get('/api/overtimes/total', {
    params: {
      year: year.value,
      month: month.value,
    },
  });
  perYear.value = response.data.data.year;
  perMonth.value = response.data.data.month;
}

onMounted(() => {
  getOvertimes();
  totalOvertimes();
});
</script>

<template>
  <div class="flex-col w-full">
    <header class="flex justify-between w-full">
      <div>
        <button
          @click="showModal = true"
          class="px-2 py-1 text-lg text-white bg-gray-600 rounded"
        >
          Apply
        </button>
      </div>
    </header>
    <!-- <div class="grid grid-cols-2 py-4 mt-2 justify-items-center">
      <div>
        <div class="text-6xl font-bold text-center text-green-300">{{ perMonth }}</div>
        <div>hours / month</div>
      </div>
      <div>
        <div>hours / year</div>
        <div class="text-6xl font-bold text-center text-green-600">{{ perYear }}</div>
      </div>
    </div> -->
    <div class="py-4 mt-2"></div>
    <div>
      <YearMonthPicker
        :year="year"
        :month="month"
        :is_approved="is_approved"
        @setYear="changeYear"
        @setMonth="changeMonth"
        @setIsApproved="changeIsApproved"
      />
    </div>
    <hr class="my-4" />
    <OvertimeTable :overtimes="overtimes" @show="getOvertime" />
    <vue-final-modal
      classes="flex justify-center items-center"
      v-model="showModal"
      @submit="closeModal"
    >
      <ApplyOvertime />
    </vue-final-modal>
    <vue-final-modal
      classes="flex justify-center items-center shadow-lg"
      v-model="showDetail"
    >
      <OvertimeDetail :overtime="overtime" @delete="deleteOvertime" />
    </vue-final-modal>
  </div>
</template>
